module.exports = __webpack_public_path__ + "assets/31zp24lsD9.woff";